<script setup lang="ts">
import { useEditor, useList } from '../composables'

const editor = useEditor()
useList(editor)
</script>

<template />
